import cc from 'classcat';
import { observer } from 'mobx-react';
import * as React from 'react';
import { MediaData } from '../stores';

@observer
export class MediaItem extends React.Component<{ data: MediaData }> {
    render() {
        const { type, ...data } = this.props.data;

        switch (type) {
            case 'article':
            case 'blog':
            case 'slides':
                return (
                    <li><a className={cc([type])} href={data.link}>{data.caption}</a></li>
                );
            case 'conference':
            case 'video':
            default:
                return null;
        }

    }
}
